import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';
import { useDispatch } from 'react-redux';

const changeAddresses = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/address/${shutdownId}`,
    data,
    'Не удалось сохранить измененные адреса',
    'Error'
  );

  return res;
};

export const useShutdownAddressesChange = (options = {}) => {
  const dispatch = useDispatch();

  const changeMutation = useMutation(changeAddresses, {
    ...options,
    onSuccess: async (res, { shutdownId }) => {
      if (res !== 'Error') {
        dispatch(fetchShutdownsThunk());
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
